import React, { useEffect, useState } from 'react';

// Componentes STT
import { Cache } from '@stt-componentes/cache';
import { SttCacheManager } from '@stt-componentes/core-v2';

/* @useSignals */
import { alterarUsuario } from '../../signals/usuario';
import { onlineSignal } from '../../signals/conectividade';
import { carregandoSignal } from '../../signals/carregando';
import SttCarregando from '../../componentes/comum/SttCarregando/SttCarregando';

const Autenticacao = ({ onLoaded }) => {
    const offline = !onlineSignal.value;

    return (
        <>
            {carregandoSignal.value && <SttCarregando />}
            <SttCacheManager
                config={global.gConfig}
                offline={offline}
                onSync={(loaded) => {
                    carregandoSignal.value = !loaded;
                    const userInfo = Cache.getUserInfo();
                    alterarUsuario(userInfo);
                    onLoaded(loaded);
                }}
            />
        </>
    );
};

export default Autenticacao;
